<section class="overview">
  <!-- 1st row dropdown portion -->
  <div class="justify-content mb-5">
    <div class="d-flex">
      <div class="left-border"></div>
      <p class="title">Audit Activity Overview</p>&nbsp;&nbsp;<i class="pi pi-refresh"
                                                                 style="cursor:pointer;"
                                                                 (click)="refreshAuditOverview()"></i>
    </div>
    <div class="right-algin">
      <p-dropdown [options]="filter" optionLabel="name"></p-dropdown>
      <p-dropdown [options]="days" optionLabel="name"></p-dropdown>
      <div class="icon-place-holder-2"><img class="UI-icon-group-light" src="assets/images/svg/more.svg" /></div>
    </div>

  </div>
  <!-- end -->
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-3 col-border">
        <div class="div">
          <div class="info mx-3">
            <div class="mb-15">
              <div class="icon-place-holder icon-charge">
                <div class="group">
                  <div class="overlap">
                    <img src="assets/images/svg/charge.svg" />
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-15">
              <div class="frame mb-15">
                <div class="caption flex-align-center mb-15">
                  <div class="customers">Total Audits</div>
                  <img class="img" src="assets/images/svg/warning.svg" />
                </div>
                <div class="element-number">{{totalAuditEvents | number}}</div>
              </div>
              <div class="component flex-align-center mb-15" *ngIf="totalChanges.totalAudits > 0">
                <img class="img" src="assets/images/svg/up.svg" />
                <span class="text-percent">{{percentageChanges.totalAudits | number:'1.2-2'}}%</span>
                <span class="text-wrapper" *ngIf="totalChanges.totalAudits > 0">({{totalChanges.totalAudits | number}})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-border pl-35">
        <div class="div">
          <div class="info mx-3">
            <div class="mb-15">
              <div class="icon-place-holder insertion-icon">
                <img class="icon-size" src="assets/images/svg/insertion-icon.svg" />
              </div>
            </div>
            <div class="mb-15">
              <div class="frame mb-15">
                <div class="caption flex-align-center mb-15">
                  <div class="customers">Total Inserts</div>
                  <img class="img" src="assets/images/svg/warning.svg" />
                </div>
                <div class="element-number">{{totalInsertions | number}}</div>
              </div>
              <div class="component flex-align-center mb-15" *ngIf="totalChanges.totalInserts > 0">
                <img class="img" src="assets/images/svg/up.svg" />
                <span class="text-percent">{{percentageChanges.totalInserts | number:'1.2-2'}}%</span>
                <span class="text-wrapper" *ngIf="totalChanges.totalInserts > 0">({{totalChanges.totalInserts | number}})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 col-border pl-35">
        <div class="div">
          <div class="info mx-3">
            <div class="mb-15">
              <div class="icon-place-holder update-icon">
                <img class="icon-size" src="assets/images/svg/update-icon.svg" />
              </div>
            </div>
            <div class="mb-15">
              <div class="frame mb-15">
                <div class="caption flex-align-center mb-15">
                  <div class="customers">Total Updates</div>
                  <img class="img" src="assets/images/svg/warning.svg" />
                </div>
                <div class="element-number">{{totalUpdates | number}}</div>
              </div>
              <div class="component flex-align-center mb-15" *ngIf="totalChanges.totalUpdates > 0">
                <img class="img" src="assets/images/svg/up.svg" />
                <span class="text-percent">{{percentageChanges.totalUpdates | number:'1.2-2'}}%</span>
                <span class="text-wrapper" *ngIf="totalChanges.totalUpdates > 0">({{totalChanges.totalUpdates | number}})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 pl-35">
        <div class="div">
          <div class="info mx-3">
            <div class="mb-15">
              <div class="icon-place-holder deletion-icon">
                <img class="icon-size" src="assets/images/svg/deletion.svg" />
              </div>
            </div>
            <div class="mb-15">
              <div class="frame mb-15">
                <div class="caption flex-align-center mb-15">
                  <div class="customers">Total Deletes</div>
                  <img class="img" src="assets/images/svg/warning.svg" />
                </div>
                <div class="element-number">{{totalDeletions | number}}</div>
              </div>
              <div class="component flex-align-center mb-15" *ngIf="totalChanges.totalDeletes > 0">
                <img class="img" src="assets/images/svg/up.svg" />
                <span class="text-percent">{{percentageChanges.totalDeletes | number:'1.2-2'}}%</span>
                <span class="text-wrapper" *ngIf="totalChanges.totalDeletes > 0">({{totalChanges.totalDeletes | number}})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
